import { authorizedOnly } from 'SharedDir/router/helpers';

const FillStep = () =>
  import(/* webpackChunkName: "Issue" */ 'PortalDir/modules/Issues/pages/FillStepPortal.vue');

const FillStepSkeleton = () =>
  import(/* webpackChunkName: "Issue" */ 'PortalDir/modules/Issues/pages/FillStepSkeleton.vue');

const Card = () =>
  import(/* webpackChunkName: "IssueCard" */ 'PortalDir/modules/Issues/pages/Card.vue');

export default [
  {
    path: 'card/:id',
    name: 'issue-card',
    component: Card,
    props: true,
  },
  {
    path: ':id/step/:stepId?',
    name: 'issue-fill-step',
    // component: FillStep,
    // Применяем грязый хак, если нужно чтобы определенная страница загрузилась в SPA
    component: typeof window === 'undefined' ? FillStepSkeleton : FillStep,
    props: true,
  },
];
